import { alpha, Box, Button, Stack, useTheme } from "@mui/material";
import type { FormEventHandler } from "react";
import type { UseFormReturn } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { FilterFormValues } from "web_myplann/Portfolio/Components/Redesign/Filter/filterFormSchema";
import { PortfolioFilterFormFields } from "web_myplann/Portfolio/Components/Redesign/Filter/PortfolioFilterFormFields";

type Props = {
	form: UseFormReturn<FilterFormValues>;
	onSubmit: FormEventHandler<HTMLFormElement>;
};

export const PortfolioFilterForm = ({ form, onSubmit }: Props) => {
	const { t } = useResource();
	const theme = useTheme();

	const pageBg = theme.palette.grey[50];

	return (
		<Stack component="form" onSubmit={onSubmit}>
			<PortfolioFilterFormFields control={form.control} />

			<Box
				px={theme.spacingTokens.lg}
				pt={theme.spacingTokens.xxl}
				pb={theme.bottomSpacing.stickyCta}
				position="sticky"
				bottom={0}
				zIndex={1}
				sx={{
					background: `linear-gradient(to top, ${pageBg} 0%, ${pageBg} 60%, ${alpha(pageBg, 0)} 100%)`,
				}}
			>
				<Button variant="primary" type="submit">
					{t(Resources.Portfolio.List.Redesign.Filter.apply)}
				</Button>
			</Box>
		</Stack>
	);
};
